import { create } from "zustand";

export const usePhoneInventoryStore = create((set, get) => ({
  isPurchaseNumberPanelOpen: false,

  currentStep: 1,
  selectedNumber: null,
  searchFilters: {
    country: "US",
    capabilities: ["Call", "SMS"],
    searchCriteria: "Number",
    matchTo: "First part of number",
  },

  purchaseData: {
    numberAccess: "assigned",
    assignedUsers: [],
    numberLabel: "",
  },

  //  NEW: Context tracking
  purchaseContext: null,
  contextData: null,
  sourceComponent: null,

  openPurchaseNumberPanel: (context = "inventory", contextData = null) => {
    const defaultPurchaseData = {
      numberAccess: "assigned",
      assignedUsers: [],
      numberLabel: "",
    };

    if (context === "add-user" && contextData?.selectedUser) {
      const selectedId = contextData.selectedUser.id;
      defaultPurchaseData.assignedUsers = selectedId ? [selectedId] : [];
      defaultPurchaseData.numberAccess = "assigned";
    }

    set({
      isPurchaseNumberPanelOpen: true,
      currentStep: 1,
      purchaseContext: context,
      contextData: contextData,
      purchaseData: defaultPurchaseData,
      selectedNumber: null,
    });
  },

  closePurchaseNumberPanel: () =>
    set({
      isPurchaseNumberPanelOpen: false,
      currentStep: 1,
      selectedNumber: null,
      purchaseContext: null,
      contextData: null,
      purchaseData: {
        numberAccess: "assigned",
        assignedUsers: [],
        numberLabel: "",
      },
    }),

  setCurrentStep: (step) => set({ currentStep: step }),
  goToNextStep: () => set((state) => ({ currentStep: Math.min(state.currentStep + 1, 3) })),
  goToPreviousStep: () => set((state) => ({ currentStep: Math.max(state.currentStep - 1, 1) })),

  setSelectedNumber: (number) => set({ selectedNumber: number }),
  setSearchFilters: (filters) => set((state) => ({ searchFilters: { ...state.searchFilters, ...filters } })),
  setPurchaseData: (data) => set((state) => ({ purchaseData: { ...state.purchaseData, ...data } })),

  completePurchase: (purchasedNumber) => {
    const { purchaseContext, contextData } = get();

    // Emit context-specific events
    if (purchaseContext === "add-user") {
      window.dispatchEvent(
        new CustomEvent("numberSelectedForUser", {
          detail: { number: purchasedNumber, user: contextData?.selectedUser },
        })
      );
    } else {
      window.dispatchEvent(
        new CustomEvent("numberAddedToInventory", {
          detail: { number: purchasedNumber },
        })
      );
    }
  },
}));
